import React, { useState, useEffect } from "react";
import { Card, Button } from "react-bootstrap";

function DownloadApp() {
  return (
    <div className="center-screen subscription-checkout">
      <Card style={{ width: "29rem" }}>
        <Card.Body>
          <h3 className="info-text">
            Success. Thanks for joining VPAR Premium!
          </h3>
          <br />
          You're all set. Please now return to your phone, open the VPAR app and
          enjoy your Premium benefits.
          <br />
          <br />
          If you have any questions or issues, please contact the team - 
          <a href = "mailto:support@vpar.com."> support@vpar.com.</a>
        </Card.Body>
      </Card>
    </div>
  );
}

export default DownloadApp;
